import './Footer.css';

export const Footer = (props) => {
    return (<div className="Footer">
        {
            props.info.map((line) => (<div>{line}</div>))
        }
    </div>);
};
